<template>
  <div class="outer-div">
    <app-toolbar :background="false"></app-toolbar>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8" class="central-text">
          {{ $store.state.websiteVariables.landingHeader }}
        </v-col>
      </v-row>
    </v-container>
    <div class="action-button d-flex justify-center">
      <v-btn
        v-if="
          user && (user.admin || (user.emailVerified && user.accessGranted))
        "
        large
        tile
        color="primary"
        to="/explore"
        >Explore Data</v-btn
      >
      <v-btn
        v-else-if="user"
        large
        tile
        color="primary"
        to="/application-status"
        >Application Status</v-btn
      >
      <v-btn v-else large tile color="primary" to="/request-access"
        >Request Access</v-btn
      >
    </div>
  </div>
</template>

<style scoped>
.outer-div {
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.8)
    ),
    url("~@/assets/images/scans.jpg");
  background-size: cover;
  padding-bottom: 60px;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.central-text {
  text-align: center;
  font-size: 2.8rem;
  color: white;
  margin-bottom: 50px;
  margin-top: 80px;
}

@media (max-width: 600px) {
  .central-text {
    font-size: 1.8rem;
    margin-bottom: 20px;
    margin-top: 30px;
  }
}
</style>

<script>
import AppToolbar from "@/components/layout/Toolbar";
import { mapState } from "vuex";

export default {
  components: {
    AppToolbar
  },
  computed: {
    ...mapState(["user"])
  }
};
</script>
